import React from "react";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import {Route, Switch} from "react-router-dom";
import ProductsTagManagementListView from "./list";
import ProductsTagManagementSingleView from "./single";
import AccessDeniedView from "../../../../error/access-denied";
import ServerErrorView from "../../../../error/server-error";

const TagManagementViews = () => {

    return (
        <>
            <Switch>
                <Route path={routes.products.tags.list} exact>
                    <ProductsTagManagementListView/>
                </Route>
                <Route path={routes.products.tags.list.concat(routes.error.accessDeniedForSection)} exact>
                    <AccessDeniedView/>
                </Route>
                <Route path={routes.products.tags.list.concat(routes.error.serverErrorForSection)} exact>
                    <ServerErrorView/>
                </Route>
                <Route path={routes.products.tags.single} exact>
                    <ProductsTagManagementSingleView/>
                </Route>
            </Switch>
        </>
    );
}

export default TagManagementViews;
